import Checkbox from "../../../components/Inputs/Checkbox";
import DateInput from "../../../components/Inputs/DateInput";
import TextInput from "../../../components/Inputs/TextInput";
import RadioButton from "../../../components/Inputs/RadioButton";

const Question = ({
  data,
  index,
  answerData,
  setAnswer,
  setAdditionalValue,
  questionGroup
}) => {
  let answer = answerData && answerData.answer;
  if (data && data.question_type === "multiple") {
    return (
      <div className="mb-5">
        <div className="font-medium">
          {index + 1}. {data.question}
        </div>

        <div className="grid grid-cols-3 gap-y-2 gap-x-2 mt-2">
          {data.options &&
            data.options.map((option) => {
              return (
                <div className="flex items-center">
                  <Checkbox
                    selected={answer && answer.includes(option)}
                    onChange={() => setAnswer(data, option)}
                  />
                  <span className="ml-1">{option}</span>
                </div>
              );
            })}
        </div>
        {answer.includes("Other") && (
          <TextInput
            placeholder="other reason"
            value={answerData.value}
            onChange={(e) => setAdditionalValue(answerData, e.target.value)}
          />
        )}
      </div>
    );
  }

  if (data.question_type === "date") {
    return (
      <>
        <div className="font-medium">
          {index + 1}. {data.question}
        </div>
        <div className="grid gap-y-2 gap-x-2 mt-2 mb-5 max-w-20">
          <DateInput
            value={answer}
            onChange={(e) => setAnswer(data, e.target.value)}
          />
        </div>
      </>
    );
  }

  if (data.question_type === "boolean") {
    return (
      <div className="mb-2">
        <div className="flex items-center grid grid-cols-3 gap-y-2 gap-x-2">
          <div className={`col-span-2 ${!questionGroup && "font-medium"}`}>
            {!questionGroup && index + 1 + '.'} {questionGroup && <span className="ml-4"/>} {data.question}
          </div>
          <div className="flex items-center">
            <RadioButton
              name={data.question + "yes"}
              label={"yes"}
              selected={answer ? true : ""}
              onClick={() => setAnswer(data, true)}
            />
            <RadioButton
              name={data.question + "no"}
              label={"no"}
              selected={answer === false ? true : ""}
              onClick={() => setAnswer(data, false)}
            />
          </div>
        </div>
        {data.additional_details && answer && (
          <TextInput
            placeholder="which?"
            value={answerData.value}
            onChange={(e) => setAdditionalValue(answerData, e.target.value)}
          />
        )}
      </div>
    );
  }

  return <div>{data.question}</div>;
};

export default Question;
